import { Breadcrumbs as MantineBreadcrumbs, Anchor, ScrollArea } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconHome } from '@tabler/icons-react'

import { config } from 'src/config'
import { useLocale } from 'src/contexts/LocaleContext'
import colorVariables from 'src/styles/Colors.module.scss'

export interface BreadcrumbItem {
  title: string
  href: string
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const { language } = useLocale()
  const isMobile = useMediaQuery(`(max-width: ${config.breakpoints.md}px)`)

  if (items.length === 0) return null

  return (
    <ScrollArea type={isMobile ? 'never' : 'hover'} scrollbarSize={3} scrollHideDelay={200}>
      <MantineBreadcrumbs separatorMargin={6}>
        <Anchor href={`/${language}`} c={colorVariables['color-accent-italian']}>
          <IconHome size={18} />
        </Anchor>
        {items.map((item) => (
          <Anchor href={item.href} key={item.href} fz="xs" td="none" c={colorVariables['color-accent-italian']}>
            {item.title}
          </Anchor>
        ))}
      </MantineBreadcrumbs>

      {/* structured data for google */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Home',
                'item': `${config.host}/${language}`,
              },
              ...items.map((item, index) => ({
                '@type': 'ListItem',
                'position': index + 2,
                'name': item.title,
                'item': `${config.host}${item.href}`,
              })),
            ],
          }),
        }}
      />
    </ScrollArea>
  )
}
